"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Api;
(function (Api) {
    /**
     * ========================
     * Shared types for endpoints
     * ========================
     */
    let Endpoint;
    (function (Endpoint) {
        let Response;
        (function (Response) {
            /** Possible response codes */
            let Code;
            (function (Code) {
                /** Response was successful. The response data is also usually not empty  */
                Code["Successful"] = "00";
                /** Authentication failed */
                Code["AuthenticationFailed"] = "01";
                /** No data was found with the response. Response data is usually `null` */
                Code["DataNotFound"] = "03";
                /** The supplied user hash is invalid. You should log the user out. */
                Code["InvalidHash"] = "04";
            })(Code = Response.Code || (Response.Code = {}));
        })(Response = Endpoint.Response || (Endpoint.Response = {}));
    })(Endpoint = Api.Endpoint || (Api.Endpoint = {}));
    /**
     * ===============
     * Models
     * ===============
     */
    let Model;
    (function (Model) {
        /** Generic statuses in the API */
        let Status;
        (function (Status) {
            Status["Pending"] = "Pending";
            Status["Active"] = "Active";
            Status["Saved"] = "Saved";
            Status["Temporary"] = "Temporary";
            Status["Deleted"] = "Deleted";
        })(Status = Model.Status || (Model.Status = {}));
        /** Possible statuses for a Transaction model */
        let TransactionStatus;
        (function (TransactionStatus) {
            /** The transaction has not been charged */
            TransactionStatus["Pending"] = "Pending";
            /** An amount has been charged for the transaction */
            TransactionStatus["Charged"] = "Charged";
            /** Remittance initiated to the recipient */
            TransactionStatus["Disbursed"] = "Disbursed";
            /** Remittance to the recipient is completed */
            TransactionStatus["Completed"] = "Completed";
            /** Failed charge for the transaction */
            TransactionStatus["FailedCharge"] = "FailedCharge";
            /** Failed to disburse to the recipient */
            TransactionStatus["FailedDisburse"] = "FailedDisburse";
            /** Transaction is awaiting chargeback */
            TransactionStatus["Chargeback"] = "Chargeback";
            /** Transaction is reversed */
            TransactionStatus["Reversed"] = "Reversed";
            TransactionStatus["Processing"] = "Processing";
            TransactionStatus["Confirming"] = "Confirming";
        })(TransactionStatus = Model.TransactionStatus || (Model.TransactionStatus = {}));
        /** User roles in the application */
        let UserRole;
        (function (UserRole) {
            /** A normal user in the frontend applications */
            UserRole[UserRole["NormalUser"] = 0] = "NormalUser";
        })(UserRole = Model.UserRole || (Model.UserRole = {}));
        /** Initials for supported countries */
        let CountryInitials;
        (function (CountryInitials) {
            CountryInitials["Canada"] = "CA";
            CountryInitials["Ghana"] = "GH";
            CountryInitials["Kenya"] = "KE";
            CountryInitials["Nigeria"] = "NG";
            CountryInitials["NigeriaNig"] = "\u20A6G";
            CountryInitials["SouthAfrica"] = "ZA";
            CountryInitials["UnitedKingdom"] = "GB";
            CountryInitials["UnitedStates"] = "US";
        })(CountryInitials = Model.CountryInitials || (Model.CountryInitials = {}));
        /** Possible ways a recipient can receive payment */
        let PaymentType;
        (function (PaymentType) {
            /** Domiciliary account */
            PaymentType["DomAcc"] = "dom";
            /** Virtual domiciliary account */
            PaymentType["VDomAcc"] = "vdom";
            /** Auto domiciliary account */
            PaymentType["ADomAcc"] = "autodom";
            /** Bank account */
            PaymentType["BankAcc"] = "bank";
            /** Mobile money */
            PaymentType["MobileMoney"] = "mobile";
            /** Cash pickup */
            PaymentType["Cash"] = "cash";
            /** Gift card */
            PaymentType["GiftCard"] = "giftcard";
        })(PaymentType = Model.PaymentType || (Model.PaymentType = {}));
    })(Model = Api.Model || (Api.Model = {}));
})(Api || (Api = {}));
exports.default = Api;
